import React, { memo } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import moment from 'moment';
import isNil from 'ramda/src/isNil';
import split from 'ramda/src/split';
import CheckIcon from '@components/@core/CheckIcon';
import Thumbnail from '@components/@core/Thumbnail';

const TrainingItem = ({ task, completed = false, onClick, userId }) => {
    const { data, program_id, assigned_by, due_at, updated_at } = task;
    const { thumb_url, name } = data;

    const dueDate = isNil(due_at) ? moment(split(' ', updated_at)[0]).add(Number(data.estimated_completion), 'days').format('MMM D, YY') : moment(due_at).format('MMM D, YY');

    return (
        <div className="training-item cursor-pointer">
            <Row className="custom-row mb-5 ms-1 me-1" onClick={onClick}>
                <Col className={`d-flex tab-device pe-0 ps-0 pt-3`} sm={12} md={12}>
                    <CheckIcon className="custom-checkbox" size={26} checked={completed} />
                    <div className="d-flex d-flex-1 justify-content-between">
                        <div className="course-title ms-2">
                            <p className="dsl-m12 text-400 mb-0 align-items-center mb-1">
                                {isNil(program_id) ? (assigned_by === userId ? 'Self Assigned' : 'Health Coach Assigned') : `Health Plan Assigned : `}
                            </p>
                            <p className="dsl-m14 text-400 line-height-22 mb-2">{name}</p>
                        </div>
                        <div className="due-date w-50">
                            <p className="dsl-m12 text-400 mb-0 text-end mb-1">Due Date</p>
                            <p className="dsl-m16 text-400 text-end mb-1">
                                <span>{moment(dueDate).format('MMM D, YY')}</span>
                            </p>
                        </div>
                    </div>
                </Col>
                <div className="w-100">
                    <Thumbnail source={thumb_url} size="responsive" className="cursor-pointer" />
                </div>
            </Row>
        </div>
    );
};

export default memo(TrainingItem);
